let toastRuntimeActivated = false;
const activationListeners = new Set();

export const isToastRuntimeActivated = () => toastRuntimeActivated;

export const activateToastRuntime = () => {
  if (toastRuntimeActivated) return;
  toastRuntimeActivated = true;
  activationListeners.forEach((listener) => {
    try {
      listener(true);
    } catch (_error) {
      // no-op
    }
  });
};

export const subscribeToastRuntime = (listener) => {
  if (typeof listener !== 'function') {
    return () => {};
  }

  activationListeners.add(listener);
  if (toastRuntimeActivated) {
    listener(true);
  }

  return () => {
    activationListeners.delete(listener);
  };
};

